import { getErrorMessage } from '../../../utils/getErrorMessage';

const isString = (value: unknown) => typeof value === 'string';

// Exported error message constants
export const DEACTIVATED_ACCOUNT_ERROR_MESSAGE = "There's no account with this email, please check the email and try again or ";
export const INVALID_CODE_ERROR_MESSAGE = 'Invalid code, please check the code and try again';
export const PHONE_VALIDATION_ERROR_MESSAGE = 'Please enter a valid phone number.';

// Helper function to check if error is phone validation related
export const isPhoneValidationError = (errorData: any): boolean => {
  const errorsArray = errorData?.errors;
  if (errorsArray && Array.isArray(errorsArray)) {
    return errorsArray.some((error: any) => 
      error?.property === 'phone' || 
      error?.pointer === '/phone' ||
      (error?.message && error.message.toLowerCase().includes('phone'))
    );
  }
  
  const errorDetail = errorData?.detail;
  const errorTitle = errorData?.title;
  
  return (
    (errorDetail && errorDetail.toLowerCase().includes('phone')) ||
    (errorTitle && errorTitle.toLowerCase().includes('phone')) ||
    (errorDetail && errorDetail.includes('cell phone number'))
  );
};

export const handleError = (error) => {
  if (error?.response && error.response?.data) {
    const errorData = error.response?.data;
    const errorTitle = errorData && isString(errorData?.title) && errorData.title;
    const errorDetail = errorData && isString(errorData?.detail) && errorData.detail;
    const errorType = errorData && isString(errorData?.type) && errorData.type;
    
    // Special handling for phone validation errors
    if (isPhoneValidationError(errorData)) {
      return PHONE_VALIDATION_ERROR_MESSAGE;
    }
    
    // Special handling for deleted accounts
    if (errorType === '_auth.user_role_not_allowed_to_sign_in' || 
        errorDetail?.includes('User role is not allowed to sign in')) {
      return DEACTIVATED_ACCOUNT_ERROR_MESSAGE;
    }
    
    // Special handling for unregistered users (no account exists)
    if (errorType === '_auth.user_not_found' || 
      errorType === '_auth.no_user_role_found' ||
      errorDetail?.toLowerCase().includes('no user role found') ||
      errorTitle?.toLowerCase().includes('no user role found')) {
      return DEACTIVATED_ACCOUNT_ERROR_MESSAGE;
    }
    
    // Special handling for invalid verification codes
    if (errorType === '_auth.invalid_one_time_code') {
      return INVALID_CODE_ERROR_MESSAGE;
    }
    
    if (errorDetail) {
      const errorsArray = errorData?.errors;
      if (errorDetail === 'Invalid request.' && !!errorsArray.length) {
        const errorArrayMessage = errorsArray[0]?.message;
        if (isString(errorArrayMessage)) {
          return errorArrayMessage;
        }
      }
      return `${errorDetail} - ${errorTitle}`;
    }
    if (errorTitle) {
      return errorTitle;
    }
  }
  return getErrorMessage(error);
};
